import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MicrophoneOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.88499 13.9275C6.79814 13.5409 6.75289 13.1462 6.74999 12.75V10.5H5.24999V12.75C5.24717 13.565 5.39463 14.3735 5.68499 15.135L6.88499 13.9275ZM9.75009 11.25V5.24997C9.75009 4.00733 10.7574 2.99997 12.0001 2.99997C13.2427 2.99997 14.2501 4.00733 14.2501 5.24997V6.56247L15.7501 5.06247C15.6983 2.99141 13.9774 1.35445 11.9063 1.40622C9.83527 1.458 8.19831 3.17891 8.25009 5.24997V11.25H9.75009ZM17.25 12.75C17.244 14.8292 16.0115 16.709 14.1071 17.5435C12.2027 18.378 9.98523 18.01 8.4525 16.605L9.5175 15.5475C10.6209 16.5221 12.1925 16.7609 13.5356 16.158C14.8787 15.5552 15.7448 14.2222 15.75 12.75V9.31498L22.5 2.56498L21.4425 1.49998L1.5 21.4425L2.5575 22.5L7.3875 17.67C8.44612 18.6699 9.8024 19.2967 11.25 19.455V21H8.25V22.5H15.75V21H12.75V19.455C16.1652 19.0731 18.7484 16.1864 18.75 12.75V10.5H17.25V12.75ZM14.2501 12.75C14.2467 13.6178 13.7446 14.4064 12.9596 14.7764C12.1746 15.1465 11.2467 15.0321 10.5751 14.4825L14.2501 10.815V12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MicrophoneOff.vue"]]);
